import React, { useEffect } from "react"

const AdCardDetail = () => {
    useEffect(() => {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({})
        } catch (e) {
            console.error("Adsense push error:", e)
        }
    }, [])

    return (
        <div style={{ margin: "0 auto", maxWidth: '1184px' }}>
            <ins class="adsbygoogle"
                style={{ display: "block"}}
                data-ad-format="fluid"
                data-ad-layout-key="-6t+ed+2i-1n-4w"
                data-ad-client="ca-pub-4049903787201612"
                data-ad-slot="8323732550"></ins>
        </div>
    )
}

export default AdCardDetail
